// extracted by mini-css-extract-plugin
module.exports = {"container":"BonusSelectBox__container--39_kl","BonusGroupsWrapper":"BonusSelectBox__BonusGroupsWrapper--20KzG"};